import { SubmitPrequalResponse } from '@servicetitan/financing-api-client';
import { SubmitPrequalResponseDto } from '@servicetitan/financing-api-client/src/prequals-api';
import { createStore } from '@servicetitan/financing-utils-shared';
import { useState } from 'react';

export type PrequalificationResponse = SubmitPrequalResponseDto | SubmitPrequalResponse;

export const getSoftPrequalContinuationId = (
    response: PrequalificationResponse | null,
): string | null => {
    if (!response) {
        return null;
    }
    if ('prequalId' in response && response.prequalId) {
        return response.prequalId;
    }
    if ('loanId' in response && response.loanId) {
        return response.loanId;
    }
    return null;
};

function usePrequalificationResponse() {
    const [prequalificationResponse, setPrequalificationResponse] =
        useState<PrequalificationResponse | null>(null);
    return { prequalificationResponse, setPrequalificationResponse };
}

export const PrequalificationResponseStore = createStore(usePrequalificationResponse);
export type PrequalificationResponseStore = ReturnType<typeof usePrequalificationResponse>;
